import axios from 'axios';
const BASE_URL = process.env.REACT_APP_API_URL;

export const getEighteenMonthPlan = async () => {
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) return Promise.reject("Unauthorized");

  try {
    const response = await axios.get(
      `${BASE_URL}planner/eighteen-month-plan`,
      {
        headers: {
          'accept': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const getPlannerLabelsByYear = async (year) => {
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) return Promise.reject("Unauthorized");

  try {
    const response = await axios.get(
      `${BASE_URL}planner/labels/${year}`,
      {
        headers: {
          'accept': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching labels:', error.response?.data || error.message);
    throw error;
  }
};


export const postPlannerImage = async (targeting_year, label,study_hours_per_day,priority_subjects,learning_styles) => {
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) return Promise.reject("Unauthorized");

  try {
    const response = await axios.post(
      `${BASE_URL}planner/image`,
      {
        targeting_year,
        label,
        study_hours_per_day,
        priority_subjects,
        learning_styles
      },
      {
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error posting planner image:", error.response?.data || error.message);
    throw error;
  }
};

export const getPlannerImage = async (id) => {
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) return Promise.reject("Unauthorized");

  try {
    const response = await axios.get(
      `${BASE_URL}planner/image/${id}`,
      {
        headers: {
          'accept': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching planner image:", error.response?.data || error.message);
    throw error;
  }
};

export const updatePlanName = async (planName) => {
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) return Promise.reject("Unauthorized");

  try {
    const response = await axios.patch(
      `${BASE_URL}planner/update-plan-name`,
      {
        plan_name: planName,
      },
      {
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating plan name:", error.response?.data || error.message);
    throw error;
  }
};
